import React from "react";
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  AreaChart,
  Area,
  PieChart,
  Pie,
  CartesianGrid,
  XAxis,
  YAxis,
  Legend,
  Tooltip
} from "recharts";

const GraphBlock = ({ type, color, data, width, height }) => {
  let dataKey = "", valueKeys = [];
  const keys = Object.keys(data[0]);
  keys.forEach((key, i) => {
    if(typeof data[0][key] === 'string') dataKey = key;
    else if(typeof data[0][key] === 'number') valueKeys.push(key);
  })
  switch (type) {
    case "pie":
      return (
        <PieChart
          width={width}
          height={height}
        >
          <Pie
            data={data}
            dataKey={valueKeys[0]}
            nameKey={dataKey}
            cx="50%"
            cy="50%"
            outerRadius={100}
            fill="#82ca9d"
          />
        </PieChart>
      );
    case "line":
      return (
        <LineChart
          data={data}
          margin={{ left: 10, right: 10 }}
          width={width}
          height={height}
        >
          <CartesianGrid vertical={false} strokeOpacity={0.3} />
          <XAxis dataKey={dataKey} />
          <YAxis />
          <Tooltip />
          <Legend />
          {
            valueKeys.map((value, index) => (
              <Line
                type="monotone"
                key={value}
                dataKey={value}
                stroke={color[index % color.length]}
                activeDot={8}
              />
            ))
          }
        </LineChart>
      );
    case "bar":
      return (
        <BarChart
          data={data}
          margin={{ 
            left: 20, 
            right: 20,
            top: 10,
            bottom: 10
          }}
          width={width}
          height={height}
        >
          <CartesianGrid vertical={false} strokeOpacity={0.3} />
          <XAxis dataKey={dataKey} />
          <YAxis />
          <Tooltip />
          <Legend 
            // layout="vertical"
            // align="right"
            // verticalAlign="middle"
          />
          {
            valueKeys.map((value, index) => (<Bar key={value} dataKey={value} fill={color[index % color.length]} />))
          }
        </BarChart>
      );
    case "area":
      return (
        <AreaChart
          data={data}
          margin={{ left: 10, right: 10 }}
          width={width}
          height={height}
        >
          <CartesianGrid vertical={false} strokeOpacity={0.3} />
          <XAxis dataKey={dataKey} />
          <YAxis />
          <Tooltip />
          <Legend />
          {
            valueKeys.map((value, index) => (
              <Area
              type="monotone"
                key={value}
                dataKey={value}
                stackId="1"
                fill={color[index % color.length]}
                stroke={color[index % color.length]}
                />
            ))
          }
        </AreaChart>
      );
    default:
      return null;
  }
};

export default GraphBlock;
